import { CircularProgress, Icon } from '@mui/material';
import MyGridView from 'components/GridView';
import Footer from 'examples/Footer';
import DashboardLayout from 'examples/LayoutContainers/DashboardLayout';
import DashboardNavbar from 'examples/Navbars/DashboardNavbar';
import MyFunctions from 'functions/myFunctions';
import withAuth from 'functions/withAuth';
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import offersService from 'services/offersService';

const OffersList = () => {
    const [data, setData] = useState([]);
    const [isDataLoaded, setIsDataLoaded] = useState(false);
    let navigate = useNavigate();

    function getAllCustomersClasses() {
        offersService.getAll().then(res => {
            setData([...res]);
            setIsDataLoaded(true);
        });
    }

    useEffect(() => {
        getAllCustomersClasses();
    }, []);

    if (!isDataLoaded) {
        return (
            <DashboardLayout>
                <DashboardNavbar />
                <CircularProgress color="success" size={60} />
                <p style={{ color: 'green' }}>الرجاء الإنتظار</p>
            </DashboardLayout>
        )
    }

    return (
        <DashboardLayout>
            <DashboardNavbar />
            <div className="_container">
                <MyGridView
                    source={data}
                    columns={[
                        {
                            "field": "offerTitle",
                            "headerText": "الاسم",
                            "width": 70,
                            "textAlign": "right"
                        },
                        {
                            "field": "endDate",
                            "headerText": "تاريخ الانتهاء",
                            "width": 90,
                            "textAlign": "right",
                            "type": "date",
                            "format": "dd/MM/yyyy",
                        },
                    ]}
                    allowFiltering={true}
                    actionButtons={[
                        {
                            "content": <Icon color='info'>edit</Icon>,
                            "action": (id) => {
                                return navigate("/offers/" + id)
                            }
                        },
                        {
                            "content": <Icon color='error'>delete</Icon>,
                            "action": (id) => {
                                MyFunctions.showConfirmationMessage("عملية حذف", "هل أنت متأكد من الحذف!", () => {
                                    offersService.delete(id).then(res => {
                                        getAllCustomersClasses();
                                    });
                                })
                            }
                        },
                    ]}
                    addAction={() => {
                        return navigate("/offers/" + 0)
                    }}
                />
            </div>
            <Footer />
        </DashboardLayout>
    );
}

export default withAuth(OffersList);
